  <template>
    <div>
      <hr>
        <div class="mb-3">
          <table class="tablaBusqueda">
            <tr>
<!--
              <td><label for="nombre" class="form-label">Nombre</label></td>
              <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
              <td>
                <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                  <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
                </button>
              </td>
              <td>
                <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                  <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
                </button>
              </td>
-->
              <td>
                <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                  <span class="material-symbols-outlined" style="font-size:24px;color:green; cursor: pointer;">subscriptions</span>
                  Actualizar Plan/Suscripción
                </button>
                <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="finalizarPlan" title="Nuevo registro">
                  <span class="material-symbols-outlined" style="font-size:24px;color:red; cursor: pointer;">subscriptions</span>
                  Finalizar Plan/Suscripción
                </button>
              </td>
            </tr>
          </table>
        </div>
      <table class="table table-striped" id="sampleTable">
        <thead>
          <tr>
            <th scope="col">Plan</th>
            <th scope="col">Fecha Desde</th>
            <th scope="col">Fecha Hasta</th>
            <th scope="col">Forma de Pago</th>
            <th scope="col" style="text-align: right;">Núm. Máx. Usr.</th>
            <th scope="col">Estado</th>
            <th scope="col">Usuario</th>
            <th scope="col">Opciones</th>
          </tr>
        </thead>
        <tbody>
<!--           <tr v-for="suscripcion in datosPaginados" :key="suscripcion.idSuscripcion" @click="handleRowClick($event, suscripcion.idSuscripcion)"> -->
          <tr v-for="suscripcion in datosPaginados" :key="suscripcion.idSuscripcion">
              <td>{{suscripcion.planNombre}}</td>
            <td>{{getFormattedDate(suscripcion.fechaDesde, 'DD/MM/YYYY')}}</td>
            <td>{{getFormattedDate(suscripcion.fechaHasta, 'DD/MM/YYYY')}}</td>
            <td>{{suscripcion.formaPagoNombre}}</td>
            <td style="text-align: right;">{{suscripcion.numMaxUsr}}</td>
            <td>{{suscripcion.estadoSusc}}</td>
            <td>{{suscripcion.usuarioNombre}}</td>
            <td>
              <select class="form-select form-select-sm" @change="handleAction($event, suscripcion.idSuscripcion)">
                <option disabled selected>Seleccione...</option>
                <option value="resumen">Resumen</option>
                <option value="detalles">Detalles</option>
                <option value="borrar">Borrar</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
          <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
          <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
        </ul>
      </nav>
  <!-- Modal -->
  <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="exampleModalLabel">
            <i class="fa fa-user-plus"></i> {{titulo}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <form>
          <div class="modal-body">
              <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="planNombre" class="form-label">Plan</label>
                    </div>
                    <div class="col-10">
                      <span id="planNombre" class="form-control-plaintext">{{ datoSuscripcion.planNombre }}</span>
                    </div>
                  </div>
              </div>

              <div class="mb-3" v-if="btnCrear">
                <div class="row">
                  <div class="col-2">
                    <button type="button" class="btn btn-light" @click="asignarPlan(2)">
                      <i class="material-icons" style="font-size:32px;color:lightblue; cursor: pointer;">settings</i>
                      &nbsp;&nbsp;Básico&nbsp;&nbsp;</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-light" @click="asignarPlan(3)">
                      <i class="material-icons" style="font-size:32px;color:skyblue; cursor: pointer;">settings</i>
                      &nbsp;&nbsp;Plus&nbsp;&nbsp;</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-light" @click="asignarPlan(4)">
                      <i class="material-icons" style="font-size:32px;color:steelblue; cursor: pointer;">settings</i>
                      &nbsp;&nbsp;Pro&nbsp;&nbsp;</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-light" @click="asignarPlan(5)">
                      <i class="material-icons" style="font-size:32px;color:silver; cursor: pointer;">settings</i>
                      &nbsp;&nbsp;Silver&nbsp;&nbsp;</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-light" @click="asignarPlan(6)">
                      <i class="material-icons" style="font-size:32px;color:gold; cursor: pointer;">settings</i>
                      &nbsp;&nbsp;Golden&nbsp;&nbsp;</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-light" @click="asignarPlan(7)">
                      <i class="material-icons" style="font-size:32px;color:lightgray; cursor: pointer;">settings</i>
                      &nbsp;&nbsp;Platinum&nbsp;&nbsp;</button>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="formaPagoNombre" class="form-label">Forma Pago</label>
                    </div>
                    <div class="col-10">
                      <span id="formaPagoNombre" class="form-control-plaintext">{{ datoSuscripcion.formaPagoNombre }}</span>
                    </div>
                  </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="numero" class="form-label">Número</label>
                  </div>
                  <div class="col-10">
                    <span id="numero" class="form-control-plaintext">{{ datoSuscripcion.numero }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaDesde" class="form-label">Fecha Desde</label>
                  </div>
                  <div class="col-10">
                    <span id="fechaDesde" class="form-control-plaintext">{{ getFormattedDate(datoSuscripcion.fechaDesde) }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaHasta" class="form-label">Fecha Hasta</label>
                  </div>
                  <div class="col-10">
                    <span id="fechaHasta" class="form-control-plaintext">{{ getFormattedDate(datoSuscripcion.fechaHasta) }}</span>
                  </div>
                </div>
              </div>
              <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
              <div v-if="mostrarBloque" class="mb-3">
                <div class="mb-3" v-if="btnEditar">
                  <div class="row">
                    <div class="col-2">
                      <label for="idSuscripcion" class="form-label">IdSuscripcion</label>
                    </div>
                    <div class="col-10">
                      <span id="idSuscripcion" class="form-control-plaintext">{{ datoSuscripcion.idSuscripcion }}</span>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="idUsuario" class="form-label">IdUsuario</label>
                    </div>
                    <div class="col-10">
                      <span id="idUsuario" class="form-control-plaintext">{{ datoSuscripcion.idUsuario }}</span>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="fechaReg" class="form-label">FechaReg</label>
                    </div>
                    <div class="col-10">
                      <span id="fechaReg" class="form-control-plaintext">{{ datoSuscripcion.fechaReg }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </form>
      </div>
    </div>
  </div>
    </div>
  </template>
  <script>
  import { validarForm } from '@/modules/validacionesForms.js'
  import dateFormat from '@/modules/dateFormat.js';
  
  import api from "@/services/api";
  import * as $ from 'jquery';
  window["$"] = $;
  window["jQuery"] = $;
  export default {
    props: {
      p_idEmpresa: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        suscripcions : [],
        datoSuscripcion : {},
        nombreBusqueda: '',
        titulo: '',
        btnCrear: false,
        btnEditar: false,
        elementosPorPagina: 10,
        datosPaginados: [],
        paginaActual: 1,
        modalWindow: true,
        plans: [],
        formaPagos: [],
        mostrarBloque: false,
        estiloImagen: {
          width: "200px",
          height: "200px"
        }
      }
    },
    mounted () {
      this.getDataPaginaTodos(this.paginaActual)
      this.fetchPlans()
      this.fetchFormaPagos()
    },
    methods : {
      handleRowClick(event, idSuscripcion) {
        if (event.target.tagName === 'SELECT' || event.target.tagName === 'OPTION') {
          return;
        }
        this.abrirEditar(idSuscripcion);
      },
      handleAction(event, idSuscripcion) {
        const action = event.target.value;
        if (action === 'resumen') {
          this.abrirModalEditar(idSuscripcion);
        } else if (action === 'detalles') {
          this.abrirEditar(idSuscripcion);
        } else if (action === 'borrar') {
          this.deleteSuscripcion(idSuscripcion);
        }
        event.target.value = 'Seleccione...';
      },
      getFormattedDate(date) {
        return dateFormat.getFormattedDate(date);
      },
      asignarPlan(plan) {
        this.datoSuscripcion.idPlan = plan;
      },
      mostrarOcultarBloque() {
        this.mostrarBloque = !this.mostrarBloque;
      },
      totalPaginas(){
        return Math.ceil(this.suscripcions.length / this.elementosPorPagina)
      },
  /*     getDataPagina(noPagina){
        if(this.nombreBusqueda != '') {
          api.get('/vwsuscripcions/nombre/'+this.nombreBusqueda).then(response=>{
            this.suscripcions=response.data.reverse();  
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
            let fin = (noPagina * this.elementosPorPagina);
            this.datosPaginados = this.suscripcions.slice(ini,fin);
          });
        }
      }, */
      getDataPaginaTodos(noPagina){
        api.get('/vwsuscripcions/idempresa/'+this.p_idEmpresa).then(response=>{
        this.suscripcions=response.data.reverse();  
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
        let fin = (noPagina * this.elementosPorPagina);
        this.datosPaginados = this.suscripcions.slice(ini,fin);
        });
      },
      getPreviousPage(){
        if(this.paginaActual > 1){
          this.paginaActual--;
        }
        this.getDataPaginaTodos(this.paginaActual);
      },
      getNextPage(){
        if(this.paginaActual < this.totalPaginas()){
          this.paginaActual++;
        }
        this.getDataPaginaTodos(this.paginaActual);
      },
      isActive(noPagina){
        return noPagina == this.paginaActual ? 'active' : ''
      },
      validarForm(){
        const requiredFields = [
          'idPlan'
  //        ,'idUsuario'
          ,'idFormaPago'
          ,'numero'
  //        ,'fechaDesde'
  //        ,'fechaHasta'
        ];
        const requiredFieldsText = [
          'idPlan'
  //        ,'idUsuario'
          ,'idFormaPago'
          ,'numero'
  //        ,'fechaDesde'
  //        ,'fechaHasta'
        ];
        return validarForm(this.datoSuscripcion, requiredFields, requiredFieldsText);
      },
      abrirModalCrear(){
        this.modalWindow = true
        this.datoSuscripcion={}
        this.titulo   = 'Crear Suscripción'
        this.btnCrear = true
        this.btnEditar= false
      },
      abrirModalEditar(idSuscripcion){
        this.modalWindow = true
        if(idSuscripcion != null){    
            api.get('/vwsuscripcions/'+idSuscripcion).then(resp=>{
            this.datoSuscripcion = resp.data;
            });
        }
        $('#ventanaModal').modal('show');
        this.titulo   = 'Resumen de la Suscripción'
        this.btnCrear = false
        this.btnEditar= true
      },
      abrirEditar(idSuscripcion){
        if(idSuscripcion != null){
          this.$router.push('/suscripcionform/'+idSuscripcion)
        }
      },
      async deleteSuscripcion (idSuscripcion) {
        try{
          await api.delete('/suscripcions/'+idSuscripcion)
            this.getDataPaginaTodos(this.paginaActual);
        }catch(error){
          alert('No se pudo eliminar')
        }
      },    
      fetchPlans() {
        fetch('http://localhost:8080/api/v1/vwplans')
          .then(response => response.json())
          .then(data => {
            this.plans = data;
          })
          .catch(error => {
            console.error('Error fetching plans:', error);
          });
      },
      fetchFormaPagos() {
        fetch('http://localhost:8080/api/v1/vwformapagos')
          .then(response => response.json())
          .then(data => {
            this.formaPagos = data;
          })
          .catch(error => {
            console.error('Error fetching formaPagos:', error);
          });
      },
    },
  }
  </script>
  <style src="@/assets/css/listaFiltrada.css" scoped></style>
